import { FC } from "react";
import { Helmet } from "react-helmet";
import ProfilePersonalInfo from "components/ProfilePersonalInfo";
import ProfileBookings from "components/ProfileBookings";

export interface ProfilePageProps {
  className?: string;
}

const ProfilePage: FC<ProfilePageProps> = ({ className = "" }) => {
  return (
    <div className={`nc-ProfilePage ${className}`} data-nc-id="AuthorPage">
      <Helmet>
        <title>Flying Lab</title>
      </Helmet>
      <main className="container mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
        <div className="block flex-grow mb-24 lg:mb-0">
          <div className="lg:sticky lg:top-24">
            <ProfilePersonalInfo />
          </div>
        </div>

        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
          <ProfileBookings />
        </div>
      </main>
    </div>
  );
};

export default ProfilePage;
